import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { Alert } from '@mantine/core';
import type { ReactNode } from 'react';
import { Icon } from '../Spinner/Icon';
import type { AlertProps } from './AlertProps';

const AlertIcon = <Icon icon={faTriangleExclamation} />;

export function WarningAlert(props: AlertProps): ReactNode {
	const icon = props.icon ?? AlertIcon;

	return (
		<Alert c={'orange.9'} bg={'orange.1'} variant="light" title={props.title} icon={icon}>
			{props.children}
		</Alert>
	);
}
